import React from 'react';

const PerformanceSummary = ({ results, getPerformanceMessage }) => {
  return (
    <div className="col-lg-4 mb-3 mb-lg-0">
      <div className="performance-summary">
        <h6 className="text-light mb-2">Performance</h6>
        <p className="quiz-description-modern mb-2">{getPerformanceMessage(results.score)}</p>
        <small className="quiz-description-modern">
          Completed on {new Date().toLocaleDateString()}
        </small>
      </div>
    </div>
  );
};

export default PerformanceSummary;
